/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetOrCreateQrCodeRequest } from '../models/GetOrCreateQrCodeRequest';
import type { GetOrCreateQrCodeResponse } from '../models/GetOrCreateQrCodeResponse';
import type { GetQrCodeResponse } from '../models/GetQrCodeResponse';
import type { QrCodeType } from '../models/QrCodeType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class QrCodesService {
    /**
     * Get QR Code.
     * Get QR Code.
     * @param id The QR Code identifier.
     * @returns GetQrCodeResponse The QR Code.
     * @throws ApiError
     */
    public static getQrCodeEndpoint(
        id: string,
    ): CancelablePromise<GetQrCodeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/qr-codes/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The QR Code has not been found.`,
            },
        });
    }
    /**
     * Get or create QR Code.
     * Get or create QR Code.
     * @param type QR Code type.
     * @param requestBody
     * @returns GetOrCreateQrCodeResponse The QR Code.
     * @throws ApiError
     */
    public static getOrCreateQrCodeEndpoint(
        type: QrCodeType,
        requestBody: GetOrCreateQrCodeRequest,
    ): CancelablePromise<GetOrCreateQrCodeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/qr-codes/types/{type}',
            path: {
                'type': type,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The QR Code has not been found.`,
            },
        });
    }
}
